import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { addSelectedFilters } from '../../multiple-search/redux/action';
import SelectComponent from './select-component';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  t: state.i18n.t
});

export default connect(mapStateToProps, { addSelectedFilters })(SelectComponent);
